/**
 * Share-URL builder for the book review flow.
 *
 * Base: `dreamable.kids` homepage with UTM parameters. `utm_campaign=
 * book_share` distinguishes the book review flow from the audio story
 * flow (`utm_campaign=story_share`). `utm_medium` is the channel the
 * user picked (whatsapp / email / copy / web_share), `utm_content`
 * is the share-mode (cover / custom).
 */
export const BOOK_SHARE_BASE = 'https://dreamable.kids';

export type BookShareMedium = 'whatsapp' | 'email' | 'copy' | 'web_share';
export type BookShareContent = 'cover' | 'custom';

export function buildBookShareUrl(medium: BookShareMedium, content: BookShareContent): string {
  const q = new URLSearchParams({
    utm_source: 'share',
    utm_medium: medium,
    utm_content: content,
    utm_campaign: 'book_share',
  });
  return `${BOOK_SHARE_BASE}?${q.toString()}`;
}
